import { AgencyDetailsFacade } from '@shared/feature/agency-details';
import { StaticPropsComponentExtensions } from '@shared/feature/component-static-extensions';
import { DownloadEvidenceService } from '../../services/download-evidence.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { BaseModalComponent } from '@shared/ui/modal';
import { DownloadEvidenceRequest } from '../../models/request.models';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'sh-shared-layout-download-evidence-dialog',
  templateUrl: './download-evidence-dialog.component.html',
  styleUrls: ['./download-evidence-dialog.component.css'],
  standalone: false,
})
export class DownloadEvidenceDialogComponent extends StaticPropsComponentExtensions implements OnInit, OnDestroy {
  @ViewChild(BaseModalComponent) baseModal?: BaseModalComponent;

  evidenceUid = '';

  public downloadFormGroup = new FormGroup({
    reason: new FormControl('', [Validators.required]),
  });

  private ngUnsubscribe = new Subject<void>();

  constructor(
    private downloadEvidenceService: DownloadEvidenceService,
    private agencyDetailsFacade: AgencyDetailsFacade,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    super();
  }

  ngOnInit(): void {
    this.evidenceUid = this.config.data?.evidenceUid;
    this.agencyDetailsFacade
      .getAgencySettings()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((settings) => {
        if (settings.downloadReasonMinLength) {
          this.downloadFormGroup.get('reason')?.setValidators([Validators.required, Validators.minLength(settings.downloadReasonMinLength), Validators.maxLength(250)]);
        }
      });
  }

  downloadFile(): void {
    this.downloadEvidenceService.downloadEvidenceWithReasonHeader(this.evidenceUid, new DownloadEvidenceRequest(this.downloadFormGroup.controls.reason.value));
    this.ref.close();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
